import { useState, useEffect } from "react";
import { useCart } from "../context/CartContext";
import styles from "./Navbar.module.css";

const WA_CUSTOM = "https://wa.me/94765851400?text=Hi!%20I%27m%20interested%20in%20a%20custom%20jewellery%20design.%20Could%20you%20help%20me%3F";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const darkPages = ["/size-guide", "/return-policy", "/privacy-policy", "/terms-and-conditions"];
  const isDarkPage = darkPages.some(p => window.location.pathname.startsWith(p));
  const [menuOpen, setMenuOpen] = useState(false);
  const { count, setCartOpen } = useCart();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    if (window.location.pathname !== "/") {
      window.location.href = "/#" + id;
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ""}`}>
      <div className={styles.inner}>
        <div className={`${styles.logo} ${isDarkPage && !scrolled ? styles.logoDark : ""}`} onClick={() => window.location.href = "/"}>
          Ratnapura <span>Gems</span>
        </div>

        <div className={`${styles.desktopLinks} ${isDarkPage && !scrolled ? styles.linksDark : ""}`}>
          {["Collection", "Deals", "Why Us", "Contact"].map((link) => (
            <button key={link} className={styles.navLink}
              onClick={() => scrollTo(link.toLowerCase().replace(" ", "-"))}>
              {link}
            </button>
          ))}
          <a
            href="https://wa.me/94765851400?text=Hi!%20I%27m%20interested%20in%20a%20custom%20jewellery%20design.%20Could%20you%20help%20me%3F"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.navLink}
            style={{textDecoration:"none"}}
          >
            Custom Orders
          </a>
          <button className={styles.cartBtn} onClick={() => setCartOpen(true)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 01-8 0"/>
            </svg>
            {count > 0 && <span className={styles.badge}>{count}</span>}
          </button>
          <a href="tel:0765851400" className={styles.callBtn}>Call Us</a>
        </div>

        <div className={styles.mobileRight}>
          <button className={styles.cartBtn} onClick={() => setCartOpen(true)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 01-8 0"/>
            </svg>
            {count > 0 && <span className={styles.badge}>{count}</span>}
          </button>
          <button className={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            <span className={menuOpen ? styles.lineTop_open : styles.lineTop} />
            <span className={menuOpen ? styles.lineMid_open : styles.lineMid} />
            <span className={menuOpen ? styles.lineBot_open : styles.lineBot} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className={styles.mobileMenu}>
          {["Collection", "Deals", "Why Us", "Contact"].map((link) => (
            <button key={link} className={styles.mobileLink}
              onClick={() => scrollTo(link.toLowerCase().replace(" ", "-"))}>
              {link}
            </button>
          ))}
          <a href={WA_CUSTOM} target="_blank" rel="noopener noreferrer" className={styles.mobileLink} onClick={() => setMenuOpen(false)}>
            Custom Orders
          </a>
          <a href="tel:0765851400" className={styles.mobileCallBtn}>📞 076 585 1400</a>
        </div>
      )}
    </nav>
  );
}